export default "__VITE_ASSET__23eec129__"